import { cn } from '@/lib/utils'

interface SectionHeaderProps {
  title: string
  actionTitle?: string
  onAction?: () => void
  className?: string
}

/**
 * Uppercase, letter-spaced section header used above every Hearth section,
 * with an optional trailing ghost action ("View all ›").
 */
export function SectionHeader({ title, actionTitle, onAction, className }: SectionHeaderProps) {
  return (
    <div className={cn('flex items-baseline justify-between', className)}>
      <h2 className="text-[13px] font-semibold uppercase tracking-[0.08em] text-gray-500">
        {title}
      </h2>
      {actionTitle && (
        <button
          type="button"
          onClick={onAction}
          className="text-[13px] font-medium text-primary-600 hover:text-primary-700"
        >
          {actionTitle} ›
        </button>
      )}
    </div>
  )
}
